import { type FC } from 'react';
import {
  BellSimpleSlash
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconBellSimpleSlashProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconBellSimpleSlash: FC<UiIconBellSimpleSlashProps> = (props) => {
  return (
    <UiIcon
      IconComponent={BellSimpleSlash}
      {...props}
    />
  );
};
